const state = {
  chainStoreList: [],
  preAuditPrescriptionList: null,
};

const mutations = {
  SET_CHAIN_STORE_LIST(state, list) {
    state.chainStoreList = list;
  },
  SET_PRE_AUDIT_PRESCRIPTION_LIST(state, list) {
    state.preAuditPrescriptionList = list;
  },
};

const actions = {
  updateChainStoreList({ commit }, list) {
    commit("SET_CHAIN_STORE_LIST", list);
  },
  updatePreAuditPrescriptionList({ commit }, list) {
    commit("SET_PRE_AUDIT_PRESCRIPTION_LIST", list);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
